import type { JSX } from 'react';
import { Alert, List } from '@ksyos/design-system';
import type { LumbarRadiculopathyReferralData } from '@common/validation/customControls/neurology/lumbarRadiculopathy/lumbarRadiculopathyReferral/lumbarRadiculopathyReferral';
import { useEditFormSectionInputFieldContext } from '@frontend/formEngine/editForm/useEditFormContext';
import { useProcessActivityEditContext } from '@frontend/utils';

export function ExclusiecriteriaGelezen(): JSX.Element {
    const { data, errors } = useProcessActivityEditContext<LumbarRadiculopathyReferralData>();
    const { onChange } = useEditFormSectionInputFieldContext();

    const key = 'exclusiecriteria_gelezen';
    const hasError = errors.has(key);
    const isChecked = Boolean(data[key]);

    return (
        <Alert
            appearance={hasError ? 'warning' : 'info'}
            className={hasError ? 'has-danger' : ''}
        >
            Exclusiecriteria
            <Alert.Text size="sm">
                Excludeer de patiënt als ten minste één van de volgende symptomen aanwezig is
            </Alert.Text>
            <List
                size="small"
                styleType="counter"
                sx={{ mt: 2 }}
            >
                <List.Item>Recent onverklaarbaar gewichtsverlies</List.Item>
                <List.Item>Koorts of nachtelijke zweetaanvallen zonder duidelijke oorzaak</List.Item>
                <List.Item>Nachtelijke pijn die niet vermindert bij het veranderen van houding</List.Item>
                <List.Item>Voorgeschiedenis van kanker of recente trauma&apos;s (zoals valpartijen)</List.Item>
                <List.Item>Langdurig gebruik van corticosteroïden of immunosuppressiva</List.Item>
                <List.Item>
                    Zwakte in een of beide benen niet te verklaren door pijn, progressief en korter dan 24 uur bestaand
                </List.Item>
                <List.Item>
                    Gevoelloosheid in het rijbroekgebied en incontinentie en/of verlies van controle over darmen
                </List.Item>
                <List.Item>Lage rugpijn zonder uitstraling naar de bil en/of been</List.Item>
            </List>
            <Alert.Checkbox
                checked={isChecked}
                label={
                    <Alert.Text
                        as="span"
                        size="sm"
                    >
                        Ik heb de exclusiecriteria gelezen en ga akkoord*
                    </Alert.Text>
                }
                onChange={(event) => onChange(event.target.checked)}
                sx={{ mt: 4 }}
            />
        </Alert>
    );
}
